import { Text, Grid, theme, breakpoints } from '@gassan-ui'
import styled from 'styled-components'

export const Description = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: ${theme.colors.shades[500]};
`

export const Parent = styled(Grid)`
  grid-template-columns: 3.75rem 1fr;
  grid-column-gap: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid ${theme.colors.shades[200]};

  @media screen and (min-width: ${breakpoints.small}) {
    grid-template-columns: 10.5rem 1fr 7rem;
    padding-bottom: 1.75rem;
    margin-bottom: 1.75rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    grid-template-columns: 6rem 1fr 7rem;
  }

  @media screen and (min-width: ${breakpoints.xlarge}) {
    grid-template-columns: 11rem 1fr 10rem 8rem 7rem;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
  }

  @media screen and (min-width: ${breakpoints.xxlarge}) {
    grid-column-gap: 2.5rem;
  }
`
